export type AuthParams = {
  businessRegistration: boolean;
  gstVerified: boolean;
  ownerIdentity: boolean;
  physicalStore: boolean;
  productAuthenticity: boolean;
  brandAuthorization: boolean;
  invoiceVerification: boolean;
  customerSatisfaction: boolean;
  yearsInBusiness: number;
  verificationNotes: string;
};

export type Review = {
  id: string;
  reviewerName: string;
  rating: number;
  review: string;
  reviewDate: string;
  avatar: string;
};

export type Store = {
  id: string;
  name: string;
  logo: string;
  description: string;
  address: string;
  city: string;
  state: string;
  mapsLink: string;
  phone: string;
  email: string;
  website: string;
  category: string;
  averageRating: number;
  trustScore: number;
  verificationDate: string;
  verified: boolean;
  published: boolean;
  createdAt: string;
  updatedAt: string;
  reviews: Review[];
  authParams: AuthParams;
  gallery: string[];
};

export const CATEGORIES = [
'Electronics',
'Fashion & Apparel',
'Jewellery',
'Ayurveda & Health',
'Home & Furniture',
'Grocery & Organic',
'Footwear',
'Books & Stationery',
'Sports & Fitness',
'Automobiles'];


export const CITIES = [
'Mumbai',
'Delhi',
'Bengaluru',
'Hyderabad',
'Chennai',
'Pune',
'Ahmedabad',
'Kolkata',
'Jaipur',
'Surat'];


export const mockStores: Store[] = [
{
  id: 'store-001',
  name: 'Rajan Electronics Hub',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14b2e29ea-1784628052413.png",
  description:
  'Mumbai\'s most trusted electronics retailer since 2004. We stock genuine products from Samsung, Sony, LG, and Apple with factory-sealed warranty. Our trained technicians provide after-sales support and we have been GST-compliant since Day 1 of the new regime. Every product comes with an authentic invoice and serial number verification.',
  address: '42, Linking Road, Bandra West',
  city: 'Mumbai',
  state: 'Maharashtra',
  mapsLink: 'https://maps.google.com/?q=Linking+Road+Bandra+West+Mumbai',
  phone: '+91 98201 44321',
  email: 'care@rajanelectronics.in',
  website: 'https://rajanelectronics.in',
  category: 'Electronics',
  averageRating: 4.7,
  trustScore: 94,
  verificationDate: '12/03/2026',
  verified: true,
  published: true,
  createdAt: '2026-01-15',
  updatedAt: '2026-08-01',
  gallery: [
  'https://images.unsplash.com/photo-1560472355-536de3962603?w=400&h=250&fit=crop',
  'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&h=250&fit=crop',
  'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-001-1',
    reviewerName: 'Priya Sharma',
    rating: 5,
    review: 'Bought a Samsung TV here. The invoice was proper, product was sealed and the staff helped me verify the serial number on Samsung\'s website. 100% genuine.',
    reviewDate: '28/07/2026',
    avatar: 'PS'
  },
  {
    id: 'rev-001-2',
    reviewerName: 'Karthik Nair',
    rating: 5,
    review: 'Finally a store where you don\'t have to worry about grey market products. Make me Authentic verification gives me confidence.',
    reviewDate: '15/07/2026',
    avatar: 'KN'
  },
  {
    id: 'rev-001-3',
    reviewerName: 'Meera Patel',
    rating: 4,
    review: 'Good stock, slightly higher prices than online but the authenticity guarantee is worth it.',
    reviewDate: '02/07/2026',
    avatar: 'MP'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 22,
    verificationNotes: 'All 8 parameters verified. Brand authorization letters from Samsung, Sony, LG on file. Physical inspection completed 12/03/2026.'
  }
},
{
  id: 'store-002',
  name: 'Tanishq Jewels — Connaught Place',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1fadc087a-1769703864773.png",
  description:
  'Authorised franchise of Tanishq by Titan. We offer hallmarked gold, certified diamonds, and platinum jewellery with BIS hallmarking on every piece. Our store has been recognised as a top-performing franchise for three consecutive years. All diamonds come with GIA/IGI certification.',
  address: 'N-12, Connaught Place',
  city: 'Delhi',
  state: 'Delhi',
  mapsLink: 'https://maps.google.com/?q=Tanishq+Connaught+Place+Delhi',
  phone: '+91 11 4321 8765',
  email: 'cp.delhi@tanishq.co.in',
  website: 'https://tanishq.co.in',
  category: 'Jewellery',
  averageRating: 4.9,
  trustScore: 98,
  verificationDate: '05/01/2026',
  verified: true,
  published: true,
  createdAt: '2025-12-10',
  updatedAt: '2026-07-28',
  gallery: [
  'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400&h=250&fit=crop',
  'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-002-1',
    reviewerName: 'Ananya Kapoor',
    rating: 5,
    review: 'Purchased my wedding set here. Every piece came with BIS hallmark and Tanishq\'s lifetime exchange guarantee. Completely trustworthy.',
    reviewDate: '20/07/2026',
    avatar: 'AK'
  },
  {
    id: 'rev-002-2',
    reviewerName: 'Rohit Singhania',
    rating: 5,
    review: 'The diamond ring I bought came with an IGI certificate. Staff was knowledgeable and transparent about the 4Cs.',
    reviewDate: '10/06/2026',
    avatar: 'RS'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 12,
    verificationNotes: 'Tanishq franchise agreement on file. BIS hallmarking certificates verified. GIA/IGI certification process audited.'
  }
},
{
  id: 'store-003',
  name: 'Patanjali Mega Store — MG Road',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_19359a929-1767681763800.png",
  description:
  'Authorised Patanjali distributor carrying the complete product range including Ayurvedic medicines, FMCG, and organic food products. All products sourced directly from Patanjali\'s manufacturing units with batch codes. FSSAI licensed and Ayush certified outlet.',
  address: '78, MG Road, Near Brigade Junction',
  city: 'Bengaluru',
  state: 'Karnataka',
  mapsLink: 'https://maps.google.com/?q=MG+Road+Bengaluru',
  phone: '+91 80 4567 1234',
  email: 'mgroad@patanjalibengaluru.in',
  website: '',
  category: 'Ayurveda & Health',
  averageRating: 4.3,
  trustScore: 82,
  verificationDate: '18/04/2026',
  verified: true,
  published: true,
  createdAt: '2026-02-20',
  updatedAt: '2026-07-30',
  gallery: [
  'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-003-1',
    reviewerName: 'Lakshmi Venkat',
    rating: 4,
    review: 'Good stock of Patanjali products. Prices are same as MRP. I always check the batch code on Patanjali\'s app and everything matches.',
    reviewDate: '25/07/2026',
    avatar: 'LV'
  },
  {
    id: 'rev-003-2',
    reviewerName: 'Ganesh Murthy',
    rating: 5,
    review: 'Verified store with proper Ayush certification displayed. Bought Ashwagandha churna and it came with proper FSSAI label.',
    reviewDate: '08/07/2026',
    avatar: 'GM'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: false,
    yearsInBusiness: 7,
    verificationNotes: 'FSSAI license verified. Ayush certification on file. Customer satisfaction score slightly below threshold — follow-up scheduled.'
  }
},
{
  id: 'store-004',
  name: 'Bata Flagship — Phoenix MarketCity',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1960ea4d9-1785755064443.png",
  description:
  'Bata\'s flagship store at Phoenix MarketCity, Pune. Carrying the full range of Bata, Hush Puppies, and North Star footwear. All shoes are sourced directly from Bata India\'s distribution network. Authorised warranty and exchange facility available.',
  address: 'Ground Floor, Phoenix MarketCity, Nagar Road',
  city: 'Pune',
  state: 'Maharashtra',
  mapsLink: 'https://maps.google.com/?q=Phoenix+MarketCity+Pune',
  phone: '+91 20 6789 4321',
  email: 'pune.phoenix@bata.in',
  website: 'https://bata.in',
  category: 'Footwear',
  averageRating: 4.5,
  trustScore: 89,
  verificationDate: '22/02/2026',
  verified: true,
  published: true,
  createdAt: '2026-01-05',
  updatedAt: '2026-08-02',
  gallery: [
  'https://images.unsplash.com/photo-1491553895911-0055eca6402d?w=400&h=250&fit=crop',
  'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-004-1',
    reviewerName: 'Suresh Joshi',
    rating: 5,
    review: 'Bought Hush Puppies here. Genuine product with proper warranty card and Bata invoice. No grey market issues.',
    reviewDate: '30/07/2026',
    avatar: 'SJ'
  },
  {
    id: 'rev-004-2',
    reviewerName: 'Deepika Rane',
    rating: 4,
    review: 'Make me Authentic badge gives confidence. Exchange policy is hassle-free.',
    reviewDate: '18/07/2026',
    avatar: 'DR'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 15,
    verificationNotes: 'Bata India direct franchise. All brand authorization letters verified. Physical store audit completed.'
  }
},
{
  id: 'store-005',
  name: 'Urban Ladder Experience Centre',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_16cad751f-1785755064416.png",
  description:
  'Urban Ladder\'s offline experience centre in Hyderabad. Browse and purchase the full catalogue of premium furniture. All products are original Urban Ladder merchandise with QR-based authenticity verification on every item.',
  address: '3rd Floor, Inorbit Mall, Madhapur',
  city: 'Hyderabad',
  state: 'Telangana',
  mapsLink: 'https://maps.google.com/?q=Inorbit+Mall+Madhapur+Hyderabad',
  phone: '+91 40 3456 7890',
  email: 'hyderabad@urbanladder.com',
  website: 'https://urbanladder.com',
  category: 'Home & Furniture',
  averageRating: 4.6,
  trustScore: 91,
  verificationDate: '08/05/2026',
  verified: true,
  published: true,
  createdAt: '2026-03-12',
  updatedAt: '2026-07-25',
  gallery: [
  'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-005-1',
    reviewerName: 'Vikram Reddy',
    rating: 5,
    review: 'QR code on the sofa I bought links to Urban Ladder\'s product page with exact specs. Complete transparency.',
    reviewDate: '22/07/2026',
    avatar: 'VR'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 5,
    verificationNotes: 'Urban Ladder corporate-owned outlet. QR verification system audited and confirmed operational.'
  }
},
{
  id: 'store-006',
  name: 'Fabindia — Jayanagar',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_13c171dea-1785755064371.png",
  description:
  'Fabindia\'s Jayanagar store offering authentic handloom textiles, organic food, and personal care products sourced directly from Indian artisan communities. Every fabric has a weaver code traceable to the source village.',
  address: '11th Main, 4th Block, Jayanagar',
  city: 'Bengaluru',
  state: 'Karnataka',
  mapsLink: 'https://maps.google.com/?q=Fabindia+Jayanagar+Bengaluru',
  phone: '+91 80 2222 3344',
  email: 'jayanagar@fabindia.net',
  website: 'https://fabindia.com',
  category: 'Fashion & Apparel',
  averageRating: 4.4,
  trustScore: 87,
  verificationDate: '14/06/2026',
  verified: true,
  published: true,
  createdAt: '2026-04-01',
  updatedAt: '2026-07-20',
  gallery: [
  'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-006-1',
    reviewerName: 'Nandini Rao',
    rating: 4,
    review: 'Authentic handloom kurtas with weaver traceability. The weaver code on my kurta traces back to a village in Odisha — beautiful story.',
    reviewDate: '28/06/2026',
    avatar: 'NR'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: false,
    customerSatisfaction: true,
    yearsInBusiness: 9,
    verificationNotes: 'Invoice verification pending update — store using new POS system. All other parameters clear.'
  }
},
{
  id: 'store-007',
  name: 'Crossword Bookstores — Juhu',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8b09685-1785755062726.png",
  description:
  'Crossword\'s flagship Juhu store carrying over 50,000 titles across all genres. Authorised distributor for all major Indian and international publishers. All books are sourced from publishers directly — no pirated editions.',
  address: '16, Gulmohar Road, Juhu',
  city: 'Mumbai',
  state: 'Maharashtra',
  mapsLink: 'https://maps.google.com/?q=Crossword+Juhu+Mumbai',
  phone: '+91 98765 11223',
  email: 'juhu@crossword.in',
  website: 'https://crossword.in',
  category: 'Books & Stationery',
  averageRating: 4.8,
  trustScore: 92,
  verificationDate: '28/03/2026',
  verified: true,
  published: true,
  createdAt: '2026-02-05',
  updatedAt: '2026-07-15',
  gallery: [
  'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-007-1',
    reviewerName: 'Aditya Bhatt',
    rating: 5,
    review: 'Never had a piracy concern here. All books have proper publisher ISBN and price labels.',
    reviewDate: '14/07/2026',
    avatar: 'AB'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 18,
    verificationNotes: 'Publisher authorization letters on file for 200+ publishers. Anti-piracy audit completed.'
  }
},
{
  id: 'store-008',
  name: 'Decathlon — Thaltej',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_10fdd10c1-1785755064423.png",
  description:
  'Decathlon\'s Thaltej store in Ahmedabad. Carrying Decathlon\'s own brands (Quechua, Kipsta, Domyos) and selected partner brands. All products come with manufacturer warranty and Decathlon\'s 365-day return policy.',
  address: 'SG Highway, Thaltej',
  city: 'Ahmedabad',
  state: 'Gujarat',
  mapsLink: 'https://maps.google.com/?q=Decathlon+Thaltej+Ahmedabad',
  phone: '+91 79 6123 4567',
  email: 'ahmedabad.thaltej@decathlon.com',
  website: 'https://decathlon.in',
  category: 'Sports & Fitness',
  averageRating: 4.6,
  trustScore: 93,
  verificationDate: '10/04/2026',
  verified: true,
  published: true,
  createdAt: '2026-03-01',
  updatedAt: '2026-08-01',
  gallery: [
  'https://images.unsplash.com/photo-1517649763962-0c623066013b?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-008-1',
    reviewerName: 'Hardik Shah',
    rating: 5,
    review: 'Decathlon products are always genuine. Make me Authentic verification is a good added layer of trust.',
    reviewDate: '01/08/2026',
    avatar: 'HS'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 6,
    verificationNotes: 'Decathlon corporate-owned outlet. Annual audit by Decathlon India compliance team.'
  }
},
{
  id: 'store-009',
  name: 'Naturals Salon — Anna Nagar',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_113be9dfe-1782899198886.png",
  description:
  'Naturals franchise salon in Anna Nagar, Chennai. Using only Naturals-approved professional hair care products. Franchise licence valid and renewed annually. Trained stylists certified by Naturals Academy.',
  address: '2nd Avenue, Anna Nagar West',
  city: 'Chennai',
  state: 'Tamil Nadu',
  mapsLink: 'https://maps.google.com/?q=Naturals+Salon+Anna+Nagar+Chennai',
  phone: '+91 44 2345 6789',
  email: 'annanagar@naturalssalon.in',
  website: 'https://naturals.in',
  category: 'Ayurveda & Health',
  averageRating: 4.2,
  trustScore: 76,
  verificationDate: '30/05/2026',
  verified: true,
  published: true,
  createdAt: '2026-04-15',
  updatedAt: '2026-07-22',
  gallery: [],
  reviews: [
  {
    id: 'rev-009-1',
    reviewerName: 'Sowmya Krishnan',
    rating: 4,
    review: 'Good service, products are original Naturals brand. The Make me Authentic badge assured me before booking.',
    reviewDate: '20/07/2026',
    avatar: 'SK'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: false,
    customerSatisfaction: false,
    yearsInBusiness: 4,
    verificationNotes: 'Franchise agreement verified. Two parameters pending — invoice and customer satisfaction follow-up in progress.'
  }
},
{
  id: 'store-010',
  name: 'Hamleys — Quest Mall',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_111e8f300-1785755064269.png",
  description:
  'Hamleys\' flagship Kolkata store at Quest Mall. Carrying original Hamleys toys and games including exclusive UK imports. All toys are BIS-certified and meet Indian safety standards.',
  address: 'Level 3, Quest Mall, Park Street',
  city: 'Kolkata',
  state: 'West Bengal',
  mapsLink: 'https://maps.google.com/?q=Quest+Mall+Park+Street+Kolkata',
  phone: '+91 33 4567 8901',
  email: 'kolkata@hamleys.in',
  website: 'https://hamleys.in',
  category: 'Books & Stationery',
  averageRating: 4.5,
  trustScore: 88,
  verificationDate: '15/06/2026',
  verified: true,
  published: true,
  createdAt: '2026-05-01',
  updatedAt: '2026-07-30',
  gallery: [],
  reviews: [
  {
    id: 'rev-010-1',
    reviewerName: 'Debabrata Sen',
    rating: 5,
    review: 'All toys come with BIS certification labels. Kids love the store and parents can trust the products.',
    reviewDate: '29/07/2026',
    avatar: 'DS'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 8,
    verificationNotes: 'BIS certification for all toy categories verified. Hamleys India franchise agreement on file.'
  }
},
{
  id: 'store-011',
  name: 'Nalli Silks — T Nagar',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_17db25720-1785755064386.png",
  description:
  'Nalli\'s iconic T Nagar flagship store, the largest silk saree store in South India. All Kanchipuram silks carry the Silk Mark certification issued by the Silk Board of India. Handloom products are traceable to weaver cooperatives.',
  address: 'Nalli Nagar, T Nagar',
  city: 'Chennai',
  state: 'Tamil Nadu',
  mapsLink: 'https://maps.google.com/?q=Nalli+T+Nagar+Chennai',
  phone: '+91 44 2434 4115',
  email: 'tnagar@nalli.com',
  website: 'https://nalli.com',
  category: 'Fashion & Apparel',
  averageRating: 4.8,
  trustScore: 96,
  verificationDate: '02/02/2026',
  verified: true,
  published: true,
  createdAt: '2025-11-20',
  updatedAt: '2026-07-28',
  gallery: [
  'https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=400&h=250&fit=crop'],

  reviews: [
  {
    id: 'rev-011-1',
    reviewerName: 'Padmavathi Iyer',
    rating: 5,
    review: 'Silk Mark on every Kanchipuram saree. This is the gold standard for silk authenticity.',
    reviewDate: '26/07/2026',
    avatar: 'PI'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 75,
    verificationNotes: 'Silk Mark India certification verified. Weaver cooperative traceability system audited. Heritage institution.'
  }
},
{
  id: 'store-012',
  name: 'Croma — Malviya Nagar',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15976db0f-1777746335882.png",
  description:
  'Croma\'s Malviya Nagar outlet in Jaipur. Authorised retailer for all major electronics brands. Tata-owned Croma carries only factory-sealed products with manufacturer warranties. Service centre on premises.',
  address: 'Malviya Nagar, Jaipur',
  state: 'Rajasthan',
  city: 'Jaipur',
  mapsLink: 'https://maps.google.com/?q=Croma+Malviya+Nagar+Jaipur',
  phone: '+91 141 4567 8901',
  email: 'jaipur.malviya@croma.com',
  website: 'https://croma.com',
  category: 'Electronics',
  averageRating: 4.4,
  trustScore: 90,
  verificationDate: '19/05/2026',
  verified: true,
  published: true,
  createdAt: '2026-04-10',
  updatedAt: '2026-08-02',
  gallery: [],
  reviews: [
  {
    id: 'rev-012-1',
    reviewerName: 'Rahul Agarwal',
    rating: 4,
    review: 'Tata-backed store with genuine products. Extended warranty plans are transparent and fair.',
    reviewDate: '01/08/2026',
    avatar: 'RA'
  }],

  authParams: {
    businessRegistration: true,
    gstVerified: true,
    ownerIdentity: true,
    physicalStore: true,
    productAuthenticity: true,
    brandAuthorization: true,
    invoiceVerification: true,
    customerSatisfaction: true,
    yearsInBusiness: 11,
    verificationNotes: 'Tata-owned corporate outlet. Croma India compliance audit completed.'
  }
}];


export const pendingStores = [
{
  id: 'store-pending-001',
  name: 'Kalyan Jewellers — Surat',
  category: 'Jewellery',
  city: 'Surat',
  submittedDate: '01/08/2026',
  trustScore: 0
},
{
  id: 'store-pending-002',
  name: 'Organic India — Connaught Place',
  category: 'Ayurveda & Health',
  city: 'Delhi',
  submittedDate: '31/07/2026',
  trustScore: 0
},
{
  id: 'store-pending-003',
  name: 'Woodland Footwear — MG Road',
  category: 'Footwear',
  city: 'Pune',
  submittedDate: '30/07/2026',
  trustScore: 0
}];


export const adminActivityLog = [
{ id: 'log-001', action: 'Verified', store: 'Croma — Malviya Nagar', admin: 'Arjun Mehta', time: '2 hours ago', type: 'verify' },
{ id: 'log-002', action: 'Published', store: 'Hamleys — Quest Mall', admin: 'Priya Singh', time: '5 hours ago', type: 'publish' },
{ id: 'log-003', action: 'Updated Trust Score', store: 'Naturals Salon — Anna Nagar', admin: 'Arjun Mehta', time: '1 day ago', type: 'update' },
{ id: 'log-004', action: 'Unpublished', store: 'Zara — Palladium', admin: 'Priya Singh', time: '2 days ago', type: 'unpublish' },
{ id: 'log-005', action: 'Added Store', store: 'Decathlon — Thaltej', admin: 'Arjun Mehta', time: '3 days ago', type: 'add' }];